module.exports = [{"type":"hash","text":"心跳信息"},{"type":"normal","text":"當用戶的Websocket客戶端連接到Bingx Websocket服務器後，服務器會定期（當前設為5秒）向其發送心跳字符串Ping"},{"type":"normal","text":"當用戶的Websocket客戶端接收到此心跳消息後，應返回字符串Pong消息"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/swapV2/websocket/introduce/03_heart_beat.json
// module id = QDPd
// module chunks = 3